{
  "pages": {
    "edit": "Ticket editing",
    "signing_sheet": "Electronic sign",
    "history": "History"
  },
  "edit": {
    "contract_management_link": "Contract management"
  },
  "tabs": {
    "indications": "Indications",
    "planned_attendees": "Planned attendees",
    "planned_benefits": "Planned benefits",
    "contract_generation": "Contract generation",
    "signing": "Signing",
    "submission": "Submission",
    "attendance_sheet": "Attendance sheet",
    "actual_expenses_attendees": "Actual attendees/expenses"
  },
  "new": {
    "title": "Ticket New",
    "subtitle": "Specify the required information about the event",
    "layout": {
      "backLink": "Back to dashboard",
      "title": "Add Ticket"
    },
    "mandatory_notice": "Mandatory fields are marked with a *",
    "no_results": "No results",
    "input": {
      "legends": {
        "main": "Event creation",
        "main_edit": "Event edition",
        "tab_attachments": "Attachments",
        "tab_general_informations": "General information",
        "identifications": "Identifications",
        "coordinates": "Address",
        "details": "Details",
        "dates": "Dates",
        "parameters": "Settings",
        "attachments": "Attachments",
        "links": "Links",
        "allocations": "Allocations",
        "connectors": "Connectors"
      },
      "errors": {
        "name": "The name field is required",
        "internal_code": "The internal code field is required",
        "event_type": "The event field is required",
        "workflow": {
          "connect": "The workflow field is required"
        },
        "address": {
          "city": "The city field is required",
          "street_name": "The address field is required",
          "postcode": "The postal code field is required"
        },
        "initiator": "The initiator field is required",
        "validator_1": "The validator 1 field is required",
        "validator_2": "The validator 2 field is required",
        "attachments": "Please upload at least one attached file"
      },
      "event_type": "Event type",
      "event_types": {
        "EVENT": "Declared event",
        "SIMPLE_EVENT": "Simplified event",
        "UNDECLARED_EVENT": "Undeclared event",
        "DONATION": "Donation",
        "SIMPLE_DECLARATION": "Simplified declarations",
        "CONTRACT": "Contract"
      },
      "operation_type_transparency": "Operation type Transparence Santé",
      "operation_types_transparency": {
        "DOCUMENTATION_PURCHASE": "Purchase of scientific documentation",
        "SCIENTIFIC_MANIFESTATION_SPACE_PURCHASE_LEASE": "Contract for the purchase or lease of spaces for scientific events",
        "ADVERTISEMENT_SPACE_PURCHASE_LEASE": "Contract for the purchase or lease of advertising spaces",
        "SCIENTIFIC_EXPERT_CONTRACT": "Scientific expert contract",
        "SCIENTIFIC_RESEARCH_CONTRACT": "Scientific research contract",
        "SCIENTIFIC_EVALUATION_CONTRACT": "Scientific evaluation contract",
        "EXPERTISE_CONSULTING_CONTRACT_OTHER_THAN_SCIENTIFIC": "Consulting or expertise contract other than scientific",
        "INQUIRY_MARKET_STUDY_EXCLUDING_RESEARCH": "Survey, study, market study (excluding research)",
        "PARTICIPATION_CONTRACT_IN_AN_EVENT": "Participation contract in an event",
        "EVENT_SPEAKER_CONTRACT": "Speaker contract for an event",
        "TRAINING_CONTRACT": "Training contract",
        "RESEARCH_GRANT_CONTRACT": "Research grant contract",
        "AWARD_CONTRACT": "Award contract",
        "INTERVIEW_CONTRACT": "Interview contract",
        "SPONSORSHIP": "Sponsorship",
        "PATRONAGE": "Patronage",
        "PARTNERSHIP": "Partnership",
        "RIGHTS_TRANSFER_LICENSE": "Transfer of rights / licensing agreement",
        "PUBLISHING_CONTRACT": "Publishing contract",
        "COSMETIC_PRODUCT_EVALUATION": "Cosmetic product evaluation",
        "COSMETIC_PRODUCT_VIGILANCE": "Cosmetic product vigilance",
        "OTHER": "Other",
        "NOT_APPLICABLE": "Not Applicable"
      },
      "operation_type_eps": "EPS operation type",
      "operation_types_eps": {
        "AWARD_CONTRACT": "Award contract",
        "ADVERTISING_SPACE_PURCHASE_OR_RENTAL_CONTRACT": "Contrat d'achat ou de location d'espaces publicitaires",
        "CONTRACT_FOR_THE_PURCHASE_OR_RENTAL_OF_SPACES_AS_PART_OF_SCIENTIFIC_EVENTS": "Contrat d'achat ou de location d'espaces dans le cadre d'évènements scientifiques",
        "SCIENTIFIC_EVALUATION_CONTRACT": "Contrat d'évaluation scientifique",
        "EVENT_SPEAKER_CONTRACT": "Contrat d'intervenant à une manifestation",
        "SCIENTIFIC_RESEARCH_CONTRACT_EXPERTISE_CONSULTANT": "Contrat de recherche scientifique (expert, consultant)",
        "CONSULTING_OR_EXPERTISE_CONTRACT_OTHER_THAN_SCIENTIFIC_SURVEY_STUDY_MARKET_STUDY": "Contrat de conseil ou d’expertise autre que scientifique (enquête, étude, étude de marché)",
        "RESEARCH_GRANT_AWARD_CONTRACT": "Contrat de remise d'une bourse de recherche",
        "CONFERENCE_REGISTRATION_CONTRACT": "Contrat d'inscription aux congrès",
        "PATRONAGE": "Mécénat",
        "SPONSORSHIP": "Parrainage",
        "PARTNERSHIP": "Partenariat",
        "OTHER": "Autres"
      },
      "operation_type_idahe": "IDAHE operation type",
      "operation_types_idahe": {
        "CONGRESS": "Congrès",
        "GRADUATE_EDUCATION": "Formation diplômante",
        "INVESTIGATOR_MEETING": "Réunion investigateur",
        "PROFESSIONAL_MEETING": "Réunion professionnelle",
        "WEEKEND_SEMINAR": "Séminaire fin de semaine",
        "TRAINING_COURSE": "Stage de formation",
        "LABORATORY_SYMPOSIUM": "Symposium laboratoire",
        "FACTORY_VISIT": "Visite d'usine",
        "AGREEMENT_2020_0101": "Convention n°2020/01-01",
        "AGREEMENT_2020_0102": "Convention n°2020/01-02",
        "AGREEMENT_2020_02": "Convention n°2020/02",
        "AGREEMENT_2020_0301": "Convention n°2020/03-01",
        "AGREEMENT_2020_0302": "Convention n°2020/03-02",
        "AGREEMENT_2020_0401": "Convention n°2020/04-01",
        "AGREEMENT_2020_0402": "Convention n°2020/04-02",
        "AGREEMENT_2020_05": "Convention n°2020/05",
        "AGREEMENT_2024_01": "Convention n°2024/01",
        "AGREEMENT_2024_02": "Convention n°2024/02",
        "AGREEMENT_2024_03": "Convention n°2024/03",
        "AGREEMENT_2024_04": "Convention n°2024/04",
        "AGREEMENT_2024_05": "Convention n°2024/05",
        "OTHER": "Other"
      },
      "event_specialty": {
        "label": "Specialty",
        "ALLERGOLOGY": "Allergology",
        "ANATOMICAL_PATHOLOGY": "Anatomical pathology",
        "ANGIOLOGY": "Angiology",
        "MEDICAL_BIOLOGY": "Medical biology",
        "CARDIOLOGY": "Cardiology",
        "MAXILOFACIAL_SURG": "Maxilofacial surg.",
        "CARDIOVASCULAR_SURG": "Cardiovascular surg.",
        "VISCERAL_SURG": "Visceral surg.",
        "SURGERY": "Surgery",
        "FACE_SURG": "Face and neck surgery",
        "INFANT_SURG": "Infant surgery",
        "ORTHOPEDIC_SURG": "Orthopedic surgery",
        "PLASTIC_SURG": "Plastic surgery",
        "UROLOLOGIC_SURG": "Urologic surg.",
        "VASCULAR_SURG": "Vascular surg.",
        "DERMATOLOGY": "Dermatology",
        "PROFESSIONAL_DVPT": "Professional development",
        "ENDOCRINOLOGY": "Endocrinology",
        "GASTROENTEROLOGY": "Gastroenterology",
        "GENETICS": "Genetics",
        "GERIATRICS": "Geriatrics",
        "MEDICAL_GYNECOLOGY": "Medical gynecology",
        "OBSTETRIC_GYNECOLOGY": "Obstetric gynecology",
        "HEMATOLOGY": "Hematology",
        "INFECTIOLOGY": "Infectiology",
        "READAPT_MEDICINE": "Readaptation medicine",
        "EMERGENCY_MEDICINE": "Emergency medicine",
        "SPORT_MEDICINE": "Sport medicine",
        "WORK_MEDICINE": "Work medicine",
        "GENERAL_MEDICINE": "General medicine",
        "INTERN_MEDICINE": "Intern medicine",
        "NUCLEAR_MEDICINE": "Nuclear medicine",
        "THERMAL_MEDICINE": "Thermal medicine",
        "MULTIDISCIPLINARY": "Multidisciplinary",
        "NEPHROLOGY": "Nephrology",
        "NEUROSURGERY": "Neurosurgery",
        "NEUROLOGY": "Neurology",
        "NONE": "None",
        "ONCOLOGY": "Oncology",
        "OPHTALMOLOGY": "Ophtalmology",
        "ORL": "ORL",
        "PEDIATRICS": "Pediatrics",
        "PHARMACOLOGY": "Pharmacology",
        "PNEUMOLOGY": "Pneumology",
        "PSYCHIATRY": "Psychiatry",
        "MEDICAL_IMAGERY": "Medical imagery",
        "RADIOLOGY": "Radiology",
        "ANESTHESIA": "Anesthesia",
        "MEDICAL_RESEARCH": "Medical research",
        "RHEUMATOLOGY": "Rhumatology",
        "PUBLIC_HEALTH": "Public health",
        "STOMATOLOGY": "Stomatology",
        "LOCAL_TRAINING_ORG": "Local training org.",
        "TRANSPLANT": "Transplant"
      },
      "code": "Internal code",
      "quantity": "Number events",
      "operation": "Operating type",
      "event_workflow": "Workflow type",
      "event_name": "Event name",
      "creator": "Creator",
      "event_description": "Description",
      "event_description_verbose": "Event description",
      "mission_goal": "Mission goal",
      "theme": "Theme",
      "place": "Event localisation",
      "street_name": "Street name",
      "country": "Country",
      "city": "City",
      "postcode": "Postal code",
      "event_date_range": "Date, start and end.",
      "event_date_range_contract": "Date, start and end of the contract.",
      "event_date_range_open_period": "Date, start and end of open period.",
      "event_initiator": "Initiator",
      "event_validator_1": "Validator 1",
      "event_validator_2": "Validator 2",
      "event_internal_code": "Internal code",
      "simple_event_link": "Simple event(s)",
      "event_link": "Declared event(s)",
      "contract_link": "Contract(s)",
      "simple_declaration_link": "Simple Declaration",
      "undeclared_event_link": "Undeclared event(s)",
      "ticket_name": {
        "label": "Ticket name",
        "placeholder": "Ticket name"
      },
      "internal_tracking_code_name": {
        "label": "Internal code",
        "placeholder": "Internal code"
      },
      "start_at": {
        "label": "Expected launch date",
        "placeholder": "Click here to choose a date",
        "now_button": "Today"
      },
      "end_at": {
        "label": "Expected release date"
      },
      "products": "Product(s)",
      "product": "Product",
      "sectors": "Sector",
      "therapeutic_areas": "Therapeutic area",
      "units": "Unit",
      "regions": "Region",
      "networks": "Network",
      "ugas": "UGA",
      "zones": "Zone",
      "identities": "Entity",
      "attachments": {
        "drag_and_drop_statement": "Drag and drop your content here",
        "or_statement": "Or if you prefer",
        "cta_label": "Select a file from your device",
        "input_type": "Type list",
        "input_comment": "Comments",
        "placeholder": "Add a comment here",
        "file_type_description": "Please specify the type of attached file",
        "file_type": "Renseignez le type de fichier joint",
        "upload_doc": "Uploadez votre document",
        "comments": "Comments",
        "validate": "Validate",
        "error": {
          "default": "An error occurred, please try again later."
        },
        "types": {
          "REGISTRATION_FORM": "Registration form",
          "INVITATION_CARD": "Invitation card",
          "QUOTATION": "Quotation",
          "CONVENTION_LETTER": "Letter serving as convention",
          "MANDATE": "Mandate",
          "EVENT_PROGRAM": "Event program",
          "SCIENTIFIC_PROGRAM": "Scientific program",
          "OBSERVATION_BOOKLET_PROJECT": "Observation/data collection booklet draft",
          "SUMMARY": "Summary (in French)",
          "OTHERS": "Other",
          "CONTRACT_PROJECT": "Contract draft",
          "SOLICITATION_LETTER": "Solicitation letter",
          "ORDER_NOTICE": "Order notice"
        },
        "listHeader": {
          "filename": "File name",
          "period": "Period",
          "type": "Type",
          "created_at": "Created at (UTC+0)",
          "action": "Actions",
          "at": "at"
        }
      },
      "address": {
        "label": "Event localization",
        "placeholder": "Event localization"
      },
      "attendees_import": {
        "download_template": "You can download the import template before uploading your attendees",
        "drag_and_drop_statement": "Download your attendees list using the given Excel template",
        "or_statement": "XLSX",
        "cta_label": "Select a file from your device",
        "duplicates": "Attendees: { fullNames } already exist(s)."
      },
      "manager_crm": "Manager CRM",
      "approver_crm": "Approver CRM",
      "with_agency": "With agency",
      "agency_name": "Agency name",
      "format": {
        "label": "Format",
        "ONSITE": "Onsite",
        "DIGITAL": "Digital",
        "HYBRID": "Hybrid"
      },
      "meeting_type": {
        "label": "Meeting type",
        "LOCAL": "Local",
        "REGIONAL": "Regional",
        "NATIONAL": "National"
      },
      "external_code": "CRM reference",
      "crm_manager": "CRM manager",
      "contractor": "Contractor"
    },
    "tabs_header": {
      "event": "Indications",
      "attendees": "Attendees",
      "advantages": "Benefits"
    },
    "button": {
      "save": "Save",
      "submit_and_go_to_next_step": "Save and go to next step",
      "submit_and_go_to_ticket_page": "Save and go to ticket's",
      "submit_and_send_for_validation": "Save and send for validation",
      "submit_and_send_for_second_validation": "Save and send for second validation",
      "submit_and_send_back_to_initiator": "Save and send back to initiator",
      "submit_and_send_for_contract_management_stage": "Save and send to CONTRACT_MANAGEMENT_STAGE",
      "submit_and_send_for_event_validating": "Save and send to Expenses validation",
      "submit_and_send_to_event_in_progress": "Save and send to Event in progress",
      "submit_and_send_to_transparence_sante": "Save and send to Transparence Santé",
      "validate_advantages": "Actual advantages completed",
      "back_to_post_event": "Back to Post Event actions",
      "spending_complete": "Spending completed",
      "spending_denied": "Spending denied",
      "step_validated": "Validate this step",
      "archive_ticket": "Archive ticket"
    },
    "comment": {
      "placeholder": "Add your comment",
      "step": "Comment added at step \"{step}\""
    },
    "modal": {
      "title": "Please indicate the reason for returning the ticket",
      "title_denying_advantage": "Please indicate the reason for denying the advantages",
      "textarea": {
        "placeholder": "Add a comment"
      },
      "button": {
        "submit": "Add",
        "cancel": "Cancel"
      }
    },
    "popup_modal": {
      "body": "Do you confirm sending this ticket to the library?"
    },
    "toast": {
      "operation_change": "The operation change will delete the following documents: {filenames}",
      "operation_change_with_mandatory_attachments": "The operation change will delete all documents"
    }
  },
  "infos": {
    "code": "Internal file number",
    "event_type": "Type",
    "name": "Last name",
    "operation": "Operating type",
    "address": {
      "street_name": "Address",
      "postcode": "Postal code",
      "city": "City",
      "country": "Country"
    },
    "workflow": {
      "connect": "Workflow type"
    },
    "initiator": "Initiator",
    "validator_1": "Validator 1",
    "validator_2": "Validator 2",
    "place": "Event localisation",
    "start_at": "Start at",
    "end_at": "End at",
    "created_at": "Created at",
    "simple_declaration": {
      "connect": "Simple(s) declaration(s) linked"
    },
    "simple_event_link": "Simple(s) event(s) linked",
    "original_ticket_link": "Source ticket",
    "event_link": "Declared event linked",
    "contract_link": "Contracts linked",
    "undeclared_event_link": "Undeclared event(s) linked",
    "description": "Description",
    "quantity": "Number events",
    "manager_crm": "Manager CRM",
    "approver_crm": "Approver CRM",
    "agency_name": "Agency name",
    "external_code": "CRM reference",
    "createdBy": "Created by",
    "therapeutic_areas": "Therapeutic area",
    "units": "Unit",
    "regions": "Region",
    "networks": "Network",
    "ugas": "UGA",
    "zones": "Zone",
    "sectors": "Sector",
    "identities": "Identity",
    "buttons": {
      "clone": "Clone the ticket",
      "export_agency": "Export preview",
      "download_agency_export": "Download file",
      "export_agency_not_generated": "No file generated",
      "export_agency_generated_at": "File generated at: "
    }
  },
  "metadata": {
    "not_found": "N/A",
    "created_by": "Created by",
    "created_at": "Created at",
    "internal_number": "Internal file number",
    "start_at": {
      "now_button": "Today",
      "label": "Start date",
      "placeholder": ""
    },
    "end_at": {
      "now_button": "Today",
      "label": "End date",
      "placeholder": ""
    }
  },
  "show": {
    "ticket_details": "Informations {eventType}",
    "waiting_for_edit": "Waiting for edit",
    "waiting_for_validation": "Waiting for validation",
    "tabs": {
      "general_informations": "General information"
    }
  },
  "attendees": {
    "added_date": "Added the",
    "api_down": "The API is down, please try again later",
    "no_results": "No results",
    "bulk_add_success": "{count} attendee(s) added successfully.",
    "bulk_add_partial": "{created} attendee(s) added, {errors} attendee(s) already exist.",
    "bulk_add_failure": "No attendee could be added, they already exist.",
    "edit": "Attendee edition",
    "contract_create": "Create a contract via the attendee",
    "contact_create": "Create Contact",
    "create": "Create attendee",
    "save": "Save attendees",
    "attendee_list": "Attendees list",
    "search_from": "Search",
    "health_directory": "Health directory",
    "veevaSource": "Veeva",
    "contact": "Contact",
    "one_key": "OneKey",
    "manual_typing": "Manual entry",
    "list_import": "Import list",
    "list_import_history": "Import history",
    "download_sign_off_sheet": "Donwload the sign off sheet",
    "search_placeholder": {
      "firstname": "Search by first name",
      "lastname": "Search by last name",
      "health_number": "Professional number"
    },
    "export_present_doctors_as_csv": "Export present doctors list",
    "title": "Informations about the attendees",
    "subtitle": "Specify required guest information.",
    "listTitle": "Attendees list",
    "planned_amount": "Global amount of the planned advantages",
    "global_gap": "Advantage gap",
    "actual_amount": "Global amount of actual spending",
    "listHeader": {
      "id": "ID",
      "civility": "Civility",
      "name_and_health_number": "Name and RPPS",
      "name_and_specialty_and_health_number": "Name, specialty, RPPS number",
      "identity": "Identity",
      "contact_infos": "Address",
      "contact_infos_tooltip": "Sort by postal code",
      "linked_ticket_code": "Linked ticket code",
      "contract_link": "Contract linked",
      "type": "Typology",
      "category": "Category",
      "name": "Last name",
      "address": "Address",
      "email": "Mail",
      "phone": "Phone",
      "lastname": "Last name",
      "firstname": "First name",
      "healthSpecialty": "Specialty",
      "rppsNumber": "RPPS number",
      "adeliNumber": "ADELI number",
      "action": "Actions",
      "packages": "Packages",
      "planned_packages": "Planned Packages",
      "actual_packages": "Actual Packages",
      "advantage": "Advantage",
      "planned_advantages": "Planned benefits",
      "actual_advantages": "Actual spendings",
      "participation": "Participation",
      "is_billed": "Billing",
      "total_advantage_amount": "Total advantages",
      "total_actual_advantage_amount": "Total actual spendings",
      "is_threshold_reached": "Regime",
      "is_present": "Present",
      "regime": "Regime",
      "title": "Title",
      "sign": "Signature",
      "state": "State",
      "contractual_link": "Contractual link",
      "sign_sent_date": "Signature sent date",
      "signed_date": "Signature date",
      "sign_reminder_date": "Reminder date",
      "file_type": "Type",
      "created_by": "Invited by",
      "added_by": "Invited by"
    },
    "legends": {
      "main": "Main",
      "advantage": "Benefits",
      "identification": "Identification",
      "personal_information": "Personal Information",
      "representative": "Representative",
      "attendees": "Attendees",
      "validations": "Validations",
      "role": "Role",
      "contact": "Contact",
      "coordinates": "Address",
      "files": "Attachments",
      "legal_information": "Legal informations"
    },
    "infos": {
      "lastname": "Last name",
      "firstname": "First name",
      "number": "Number",
      "legal_title": "Legal entity name",
      "object_clause": "Corporate purpose",
      "description": "Corporate purpose",
      "company": "Company",
      "contractual_link": "Contractual link",
      "parent_organization_name": "Parent organization name",
      "health_number": "Identifier number",
      "health_type": "Healthcare professional type",
      "healthSpecialties": "Specialty",
      "phone_number": "Phone number",
      "email": "E-mail",
      "type": "Typology",
      "regime": "Regime",
      "is_public": {
        "label": "Public official",
        "true": "Yes",
        "false": "No",
        "public": "Public official",
        "private": "Private official"
      },
      "is_military": {
        "label": "Military",
        "true": "Yes",
        "false": "No"
      },
      "activity": "Main activity",
      "type_number": "Identifier type",
      "address": {
        "city": "City",
        "postcode": "Postal code",
        "street_name": "Address",
        "country": "Country",
        "name": "Workplace name"
      },
      "title": {
        "label": "Title",
        "PROFESSOR": "Professor",
        "DOCTOR": "Doctor"
      },
      "is_threshold_reached": {
        "label": "Regime",
        "true": "Authorization",
        "false": "Declaration"
      },
      "acronym": "Acronym",
      "legal_status": "Legal form",
      "rcs": "RCS number",
      "place_of_registration": "Place of registration",
      "capital": "Capital",
      "prefecture_name": "Prefecture name",
      "prefecture_number": "Prefecture registration number",
      "base_global_code": "Global base code",
      "ursaff_security_number": "URSSAF number",
      "social_security_number": "Social security number",
      "siret": "Siret",
      "prefecture_date": "Prefecture registration date",
      "official_journal_date": "Official journal publication date",
      "assignation": "Function",
      "external_id": "CRM code"
    },
    "inputs": {
      "select_attendee": "1. Select attendees from *",
      "data_source": {
        "label": "Data source",
        "placeholder": "Source"
      },
      "is_threshold_reached": {
        "label": "Regime",
        "true": "Authorization",
        "false": "Declaration"
      },
      "civility": {
        "label": "Civility",
        "MALE": "Sir",
        "FEMALE": "Madam",
        "UNKNOWN": "Unknown",
        "male": {
          "name": "Sir",
          "short": "M.",
          "label": "Male"
        },
        "female": {
          "name": "Madam",
          "short": "Mme",
          "label": "Female"
        },
        "unknown": {
          "name": "Unknown",
          "short": "",
          "label": "Unknown"
        }
      },
      "files": {
        "default_placeholder": "Drag and drop or click to upload"
      },
      "rib": {
        "label": "Rib",
        "placeholder": "Upload the Rib"
      },
      "status": {
        "label": "Status",
        "placeholder": "Upload the Statuts"
      },
      "official_journal": {
        "label": "Official journal",
        "placeholder": "Upload the Official Journal"
      },
      "solicitation_letter": {
        "label": "Solicitation letter",
        "placeholder": "Upload the Solicitation letter"
      },
      "receipt": {
        "label": "Receipt",
        "placeholder": "Upload the receipt"
      },
      "category": {
        "label": "Status",
        "HEALTH_PROFESSIONAL": "Healthcare professional",
        "LEGAL_ENTITY": "Legal entity",
        "STUDENT": "Student",
        "INFLUENCER": "Influencer",
        "COLLABORATOR": "Collaborator",
        "OTHER": "Other non LEA"
      },
      "type": {
        "label": "Typology",
        "AUDITOR": "Auditor",
        "SPEAKER": "Speaker/orator",
        "SPEAKER_EXPERT": "Speaker/expert",
        "SPEAKER_CONSULTANT": "Speaker/consultant",
        "OTHER": "Other",
        "INTERN": "Intern"
      },
      "title": {
        "label": "Title",
        "PROFESSOR": "Professor",
        "DOCTOR": "Doctor"
      },
      "state": {
        "label": "State",
        "PROSPECTIVE": "Prospective",
        "ATTENDEE": "confirmed",
        "NOT_SELECTED": "Not selected",
        "NOT_SUBMITTED": "Not submitted"
      },
      "lastname": "Last name",
      "firstname": "First name",
      "health_type": {
        "label": "Healthcare professional type",
        "DENTIST": "Dental surgeon",
        "DIETITIAN": "Dietitian",
        "DOCTOR": "Doctor",
        "HEAR_AID_SPECIALIST": "Hearing aid specialist",
        "LABORATORY_TECHNICIAN": "Medical laboratory technician",
        "MASSAGE_THERAPIST": "Physical therapist",
        "MEDICAL_ELECT_RADIO_MANIPULATOR": "Medical imaging technologist",
        "MIDWIFE": "Midwife",
        "NURSE": "Nurse",
        "OCCUPATIONAL_THERAPIST": "Occupational therapist",
        "ORTHOPTIST": "Orthoptist",
        "PHARMACIST": "Pharmacist",
        "PODIATRIST": "Podiatrist",
        "PSYCHOMOTRICIAN": "Psychomotor therapist",
        "SPEECH_THERAPIST": "Speech therapist",
        "ORTHOPEDIST_ORTHOTIST": "Orthopedist-orthotist",
        "OCULARIST": "Ocularist",
        "ORTHOPROSTHETIST": "Orthoprosthetist",
        "PODO_ORTHOTIST": "Podiatrist-orthotist",
        "EPITHESIST": "Epithetist",
        "CARE_GIVER": "Caregiver / Nursing assistant",
        "CHILD_CARE_ASSISTANT": "Childcare assistant",
        "DENTAL_ASSISTANT": "Dental assistant",
        "MEDICAL_PHYSICIST": "Medical physicist",
        "OPTICIAN_EYE_WEAR": "Optician / Eyewear specialist",
        "OTHER": "Other",
        "PARAMEDIC": "Ambulance worker / Paramedic",
        "PHARMACY_HOSPITAL_PREPARER": "Pharmacy / hospital pharmacy preparer",
        "OFFICINE_PHARMACY_PREPARER": "Community pharmacy preparer",
        "HOSPITAL_PHARMACY_PREPARER": "Hospital pharmacy preparer",
        "PROTHETHIST_ORTHOTIST_DISABLED": "Prosthetist and orthotist for disabled persons",
        "VETERINARY": "Veterinarian",
        "CHIROPRACTOR": "Chiropractor",
        "OSTEOPATH": "Osteopath",
        "PSYCHOTHERAPIST": "Psychotherapist"
      },
      "health_specialty": {
        "label": "Specialty"
      },
      "medical_type": {
        "label": "Invited healthcare professional types",
        "DENTAL_SURGEON": "Dental surgeons",
        "NURSE": "Nurses",
        "DOCTOR": "Doctors",
        "MIDWIFE": "Midwives",
        "MILITARY_PERSONNEL": "Military personnel",
        "PODIATRIST": "Podiatrists",
        "PHYSICAL_THERAPIST": "Physical therapists",
        "HOSPITAL_PHARMACIST": "Hospital pharmacists",
        "COMMUNITY_PHARMACIST": "Community pharmacists",
        "MINE_MUTUAL_PHARMACIST": "Industry/mutualist pharmacists",
        "BIOLOGICAL_PHARMACIST": "Biologist pharmacists",
        "OVERSEAS_PHARMACIST": "Overseas pharmacists",
        "WHOLESALE_PHARMACIST": "Wholesale pharmacists"
      },
      "pharmacist_type": {
        "label": "Pharmacist type",
        "PHARMACISTS_COMMUNITY": "Community Pharmacists (section A)",
        "PHARMACISTS_INDUSTRY": "Industry Pharmacists (section B)",
        "PHARMACISTS_WHOLESALER": "Wholesaler Pharmacists (section C)",
        "PHARMACISTS_ASSISTANT_AND_OTHERS": "Assistant Pharmacists and Others (section D)",
        "PHARMACISTS_OVERSEAS_DEPARTMENTS_AND_TERRITORIES": "Pharmacists of Overseas Departments and Territories (section E)",
        "PHARMACISTS_LIBERAL_AND_HOSPITAL_BIOLOGIST": "Liberal and Hospital Biologist Pharmacists (section G)",
        "PHARMACISTS_HEALTHCARE_INSTITUTIONS": "Healthcare Institutions Pharmacists (section H)"
      },
      "number": "Number",
      "contractual_link": {
        "label": "Contractual link",
        "BENEFICIAL_OWNER_NON_SIGNATORY": "Beneficial owner non signatory",
        "CONTRACTOR": "Contractor",
        "NON_BENEFICIAL_OWNER_CONTRACTOR": "Non-beneficial owner contractor"
      },
      "executive_role": {
        "label": "Function",
        "PRESIDENT": "President",
        "DIRECTOR": "Director",
        "TREASURER": "Treasurer",
        "SECRETARY": "Secretary"
      },
      "organization_type": {
        "label": "Oganization type",
        "ACADEMY": "Academy",
        "FOUNDATION": "Foundation",
        "LEARNED_SOCIETY": "Learned Society",
        "ADVISORY_BODY": "Advisory Body",
        "HEALTHCARE_PROFESSIONAL_ASSOCIATION": "Healthcare Professional Association",
        "STUDENT_ASSOCIATION": "Student Association",
        "HEALTHCARE_SYSTEM_USER_ASSOCIATION": "Healthcare System User Association",
        "SOFTWARE_PUBLISHER": "Software Publisher",
        "HEALTHCARE_FACILITY": "Healthcare Facility",
        "AGRICULTURAL_PROFESSIONAL_GROUP": "Agricultural Professional Group",
        "HEALTH_GROUP": "Health Group",
        "HEALTHCARE_EDUCATION_INSTITUTION": "Healthcare Education Institution",
        "PRESS_AND_MEDIA": "Press and Media",
        "CORPORATE_VETERINARY": "Corporate Veterinary",
        "OTHER": "Other"
      },
      "legal_title": "Legal entity name",
      "legal_title_and_acronym": "Name / Acronym",
      "object_clause": "Corporate purpose",
      "object_clause_tooltip": "255 characters max for submissions to professional orders",
      "description": "Corporate purpose",
      "company": "Company",
      "parent_organization_name": "Parent organization name",
      "health_number": "Identifier number",
      "rpps_number": "RPPS number",
      "adeli_number": "ADELI number",
      "city": "City",
      "postcode": "Postal code",
      "street_name": "Address",
      "address_name": "Workplace name",
      "country": "Country",
      "add": "Add",
      "modify": "Modify",
      "address": "Address",
      "phone_number": "Phone number",
      "email": "Mail",
      "legal_status": "Legal form",
      "rcs": "RCS number",
      "place_of_registration": "Place of registration",
      "capital": "Capital",
      "acronym": "Acronym",
      "prefecture_name": "Prefecture name",
      "prefecture_number": "Prefecture registration number",
      "base_global_code": "Global base code",
      "ursaff_security_number": "URSSAF number",
      "social_security_number": "Social security number",
      "siret": "Siret",
      "prefecture_date": "Prefecture registration date",
      "official_journal_date": "Official journal publication date",
      "regime": {
        "label": "Regime",
        "NON_URSSAF": "Non URSSAF",
        "URSSAF": "URSSAF"
      },
      "is_public": {
        "label": "Public official",
        "true": "Yes",
        "false": "No",
        "public": "Public official",
        "private": "Private official"
      },
      "is_military": {
        "label": "Military",
        "true": "Yes",
        "false": "No"
      },
      "activity": {
        "label": "Main activity",
        "PUPH": "PUPH",
        "HOSPITAL_UNI_NOT_PUPH": "University hospital employee non PUPH",
        "HOSPITAL_FULL_TIME": "Full-time hospital employee / State employee / PSPH employee",
        "HOSPITAL_PART_TIME": "Part-time hospital employee",
        "LIBERAL": "Private practice / Private sector employee",
        "RETIRED": "Retired",
        "INTERN": "Intern"
      },
      "type_number": {
        "label": "Identifier type",
        "ADELI": "ADELI",
        "INE": "INE",
        "RPPS": "RPPS",
        "OTHER": "Other",
        "RNA": "RNA"
      },
      "code_crm": "CRM code",
      "assignation": "Function",
      "submission_regime": {
        "AUTHORIZATION": "Authorization",
        "DECLARATION": "Declaration"
      }
    },
    "modal": {
      "title": "Attendee Edition - Not Selected",
      "description": "Changing the attendee's status to 'not selected' will remove the assigned package from the attendee.",
      "validation": "Do you want to save your changes?"
    },
    "error": {
      "default": "An error occurred, please try again later",
      "excel_file": "Veuillez selectionner un fichier Excel.",
      "data_import_fail": "Some values could not be saved."
    },
    "delete_multiple_attendees": "Delete {count} attendees",
    "delete_attendees_modal": {
      "title": "Confirmation of deletion",
      "description_multiple": "Are you sure you want to delete the {count} selected attendees?",
      "description_single": "Are you sure you want to delete the attendee:",
      "validate": "Validate"
    }
  },
  "advantages": {
    "advantages": "Benefits",
    "title": "Fill your benefits",
    "subtitle": "Specify the required benefit information.",
    "create_advantages": "Create advantages",
    "amount": "Amount",
    "amounts": "Amounts",
    "comment": "Comment",
    "area": "Area",
    "excluding_tax_amount": "Excluding tax amount",
    "gross_amount": "Gross amount",
    "including_tax_amount": "Including tax amount",
    "net_amount": "Net amount",
    "slice": "Slice",
    "add_amount": "Add amount",
    "remove_amount": "Remove amount",
    "add_advantage": "Add an advantage",
    "edit_advantage": "Edit an advantage",
    "create_pack": "Create Pack",
    "update_pack": "Update Pack",
    "pack_info": "Pack information",
    "pack_name": "Pack name",
    "quantity": "Quantity",
    "advantage_type": "Type of advantages",
    "select_pack": "Select a pack",
    "payment_date": "Payment date",
    "missing_payment_date": {
      "title": "Missing payment date",
      "description": "The following packs contain advantages without payment date :",
      "back_button": "Go to expense input"
    },
    "modal": {
      "title": "Attendee not billed",
      "description": "Assigning a pack of actual expenses to unbilled attendees is not possible. Would you like to modify your sign off sheet?",
      "button": "Go to sign off sheet"
    },
    "per_hour": {
      "preparation": "Number of hours of preparation",
      "intervention": "Number of hours of intervention"
    },
    "per_half_day": {
      "preparation": "Number of half-days of preparation",
      "intervention": "Number of half-days of intervention"
    },
    "per_day": {
      "preparation": "Number of days of preparation",
      "intervention": "Number of days of intervention"
    },
    "type": {
      "EQUIPMENT_LOAN": "Equipment loan",
      "HOSPITALITY_MEAL": "Hospitality meal",
      "HOSPITALITY_LUNCH": "Hospitality lunch",
      "HOSPITALITY_DINNER": "Hospitality dinner",
      "HOSPITALITY_NIGHT": "Hospitality night",
      "HOSPITALITY_SNACK": "Hospitality snack",
      "HOSPITALITY_TRAVEL": "Hospitality travel",
      "SALARY_AGREEMENT": "Total convention salary",
      "SALARY_HALF_DAY_PREPARATION": "Half-day salary - preparation",
      "SALARY_HOURLY_PREPARATION": "Hourly salary - preparation",
      "SALARY_DAY_PREPARATION": "Daily salary - preparation",
      "SALARY_HALF_DAY_INTERVENTION": "Half-day salary - intervention",
      "SALARY_HOURLY_INTERVENTION": "Hourly salary - intervention",
      "SALARY_DAY_INTERVENTION": "Daily salary - intervention",
      "TRAINING": "Training fees",
      "REGISTRATION_FEE": "Registration fees",
      "STAND_RENTAL": "Stand rental",
      "BOOK": "Book",
      "SUPPLY": "Supply",
      "SAMPLE": "Sample",
      "DONATION_OR_LOAN_FOR_TRAINING": "Donation or Loan for Training",
      "MATERIAL_DONATION": "Material Donation",
      "SAMPLE_DONATION": "Sample Donation",
      "BOOK_DONATION": "Book Donation",
      "DONATION_OR_LOAN_FOR_RESEARCH": "Donation or Loan for Research",
      "OPERATING_DONATION": "Operating Donation",
      "OTHER_PRODUCTS_AND_SERVICES": "Other products and services",
      "OTHER": "Other",
      "CLINICAL_STUDY": "Clinical study compensation"
    },
    "detail": "Detail",
    "browse_packs": "Browse existing packs",
    "browse_actual_packs": "Browse actual packs",
    "actual": {
      "tabs": {
        "attribution": "Allocation of actual benefits",
        "detailed_distribution": "Detailed distribution",
        "import_expenses": "Import actual expenses",
        "additional_costs": "Additional costs",
        "expense_report": "Expense reports"
      }
    },
    "clone_planned_packs": "Clone actual packs",
    "assign_planned_packs": "Assign actual packs",
    "select_packs": "Select pack",
    "create_advantage": "Create an advantage",
    "modify_amounts": "Modify amounts",
    "is_present": "Present",
    "not_present": "Not present",
    "is_billed": "Billed",
    "not_billed": "Not billed",
    "is_threshold_reached": {
      "authorization": "Authorization",
      "declaration": "Declaration"
    },
    "popup_modal": {
      "replace_pack": {
        "title": "Advantage pack change",
        "warning": "An advantage pack is already assigned to this/these attendee(s). Do you want to replace it?"
      }
    }
  },
  "contract_template": {
    "list_title": "Contract templates",
    "document_name": "Contract template name",
    "download": "Upload contract template",
    "attendees": "Attendees list",
    "uploaded_contract": "Contract template successfully added",
    "signature_request_type_row": {
      "UNORDERED": "Parallel",
      "ORDERED": "Sequential",
      "TRIPARTITE_ORDERED": "Tripartite sequential",
      "TRIPARTITE_UNORDERED": "Tripartite parallel",
      "MANUAL": "Manual"
    },
    "signature_request_type": {
      "label": "Signature request",
      "UNORDERED": "Parallel signature",
      "ORDERED": "Sequential signature",
      "TRIPARTITE_ORDERED": "Tripartite sequential signature",
      "TRIPARTITE_UNORDERED": "Tripartite parallel signature"
    },
    "alert": {
      "title": "Contract signing procedure",
      "description": "Warning, the Email field, required for sending contracts, is incomplete for some attendee(s).",
      "confirmation": "Do you want to send the signature procedure for the complete attendee(s)?",
      "email_mandatory": "An Email is required for sending contracts.",
      "email_missing": "Missing email",
      "authorization_document_missing": "Missing authorization document",
      "email_and_authorization_document_missing": "Missing email and authorization document",
      "cancel": "Complete the missing(s) email(s)",
      "send": "Send"
    }
  },
  "signing_sheet": {
    "title": "Signing sheet",
    "sign": "Signatures",
    "attendees_list": "Attendees list",
    "to_sign": "Sign the attendance sheet",
    "to_submit_and_next_step": "Save and send to next step",
    "generate": "Generation",
    "actions": "Actions",
    "download_upload": "Download/Upload",
    "tab": {
      "label": {
        "report": "Participation/Billing",
        "signing": "Electronic attendance",
        "download": "Manual attendance"
      }
    },
    "document_name": "Attendance sheet",
    "generate_signed_sheet": "Generate a signed attendance sheet",
    "generate_virgin_sheet": "Generate a virgin attendance sheet",
    "upload_manually_signed_sheet": "Upload a manually signed attendance sheet",
    "download": "Upload attendance sheet",
    "uploaded_sheet": "Attendance sheets added",
    "consent": "I certify that I have read the information relating to the collection of my data",
    "hospitality": "With hospitality",
    "delete": "Delete the signature",
    "existing_signature": "Saved signature",
    "sign_off_sheet": "sign_off_sheet",
    "history_export": "history_export",
    "listHeader": {
      "sign": "Signatures",
      "identity": "Identity",
      "filename": "File name",
      "generated_at": "Generated at",
      "created_at": "Created on",
      "actions": "Actions"
    },
    "download_template_modal": {
      "title": "Download signing sheet template",
      "options": {
        "title": "Download format",
        "pdf": {
          "title": "PDF",
          "description": "Download signing sheet template in PDF format"
        },
        "docx": {
          "title": "DOCX",
          "description": "Download signing sheet template in DOCX format"
        },
        "xlsx": {
          "title": "XLSX",
          "description": "Download signing sheet template in XLSX format"
        }
      },
      "button": {
        "validate": "Validate"
      }
    }
  },
  "expense_report": {
    "title": "Expense report",
    "add": "Add expense report",
    "reference": "Payment reference",
    "document_name": "Expense Report name",
    "inputs": {
      "name": {
        "label": "Expense report",
        "placeholder": "Please enter a title for your expense report"
      }
    },
    "download": "Upload Expense Report",
    "uploaded_report": "Expense Report successfully added",
    "listHeader": {
      "filename": "File name",
      "report": "Expense reports",
      "reference": "Payment reference",
      "actions": "Actions"
    }
  },
  "non_compliance": {
    "title": "Non Compliance",
    "add": "Add Non Compliances",
    "input_type": "Non Compliance type",
    "input_internal_code": "Non Compliance internal code",
    "item_list": "Non Compliance List",
    "listHeader": {
      "non_compliance_type": "Non Compliance type",
      "code": "Code"
    },
    "error": {
      "default": "An error occurred, please try again later"
    }
  },
  "post_event_action": {
    "title": "Post Event Actions",
    "download_history": "Download history",
    "to_archive": "To archive",
    "to_declare": "To declare",
    "to_edit_advantages": "Advantages edition",
    "modal": {
      "warning_archive": "You are going to archive this ticket",
      "warning_declare": "No declaration on Transparency Health will be possible thereafter."
    },
    "tabs": {
      "attendance_sheet": "Attendance Sheet",
      "expense_report": "Expense Report",
      "noncompliance": "Non-compliance",
      "documents": "Documents"
    }
  },
  "validation": {
    "attendee": {
      "empty_email": "Please provide an email address for each attendee"
    },
    "attachment": {
      "empty_attachment": "Please provide an attachment"
    }
  },
  "history": {
    "title": "History for ticket {ticketCode}",
    "header": "Event",
    "search_placeholder": "Search by name / first name"
  },
  "additional_costs": {
    "listHeader": {
      "type": "Type of additional cost",
      "amount": "Amount",
      "description": "Description",
      "action": "Actions"
    },
    "title": "Additional costs",
    "create_cost": "New additional cost",
    "edit_cost": "Edit additional cost",
    "inputs": {
      "type": {
        "label": "Cost type",
        "placeholder": "Please enter the cost type"
      },
      "amount": "Amount",
      "description": "Description"
    },
    "total_additional": "Additional costs total",
    "total_ticket": "Ticket total"
  },
  "infos_page": {
    "event_informations": "Event information",
    "bot_informations": "BOT submission information",
    "general_informations": "Information",
    "attendee": "Attendees",
    "advantage": "Benefits",
    "attachments_header": "Attachments",
    "manually_signed_sheets": {
      "attendees": "Attendance sheets - Attendees",
      "advantages": "Attachments - Benefits",
      "types": {
        "expenses": "Expense reports",
        "manual": "Manual attendance sheet"
      }
    },
    "generate_sign_in_sheet": "Generate an attendance sheet",
    "attachments_table": {
      "file_name": "File name",
      "comment": "Comment",
      "type": "Type",
      "action": "Actions"
    },
    "attachments": "Added attachments",
    "attendee_informations": {
      "title": "Attendee information",
      "joined_files": "Attached files",
      "attachments": "Attached documents",
      "no_joined_files": "No file available,",
      "no_generated_contracts": "No generated contract,",
      "can_you": "you can",
      "upload_generated_contracts": "generate one here.",
      "upload_joined_files": "upload one here."
    },
    "details": {
      "description": "Description",
      "event_type": "Event type",
      "code": "Internal file number",
      "workflow_name": "Internal workflow name",
      "creator": "Ticket creator",
      "initiator": "Initiator",
      "validator_1": "Validator 1",
      "validator_2": "Validator 2"
    },
    "deposit": {
      "details": {
        "initiator": "Initiator of the submission",
        "recipient": "Recipient",
        "date": "Date and time of the last submission",
        "list": "List of BOT submissions"
      },
      "submission": {
        "type": {
          "MANUAL": "Manual",
          "BOT": "Bot"
        }
      },
      "header": {
        "reference": "SUBMISSION REF",
        "date": "Bot execution time",
        "status": "STATUS",
        "link": "Submission link",
        "initiator": "Initiator",
        "json_logs": "JSON",
        "logs": "Logs",
        "packages": "Pack",
        "references": "References",
        "attachments": "Attachment name",
        "type": "Type",
        "action": "Action"
      }
    }
  },
  "deposit_management_page": {
    "idahe": "IDAHE 2",
    "eps": "EPS",
    "other": "Other",
    "regime": "Regime - {regime}",
    "deposit_disclosure": "Submission {0}",
    "documents_download_modal": {
      "title": "Dowload documents for manual despoit",
      "description": "What documents would you like to download?",
      "pdf": {
        "title": "PDF",
        "description": "Download a merged version of the {type} contracts."
      },
      "csv": {
        "title": "CSV",
        "description": "Download the list of doctors in csv format."
      },
      "archive": {
        "title": "ARCHIVE",
        "description": "Download a zip with all the {type} contracts individually."
      },
      "type": {
        "declaration": "signed",
        "authorization": "unsigned"
      },
      "no_generated_template": "No file generated",
      "generated_at": "File generated at: ",
      "completed": {
        "title": "The documents download is completed",
        "label": "Access the documents"
      },
      "processing": {
        "title": "The documents download is in progress",
        "message": "You can continue to navigate on the site while waiting for the end of the download"
      },
      "failed": {
        "title": "An error occurred while downloading the documents",
        "description": "Please try again later."
      },
      "button": {
        "validate": "Validate",
        "generate_eps": {
          "DECLARATION": "Generate signed contracts",
          "AUTHORIZATION": "Generate unsigned contracts"
        },
        "generate": "Generate",
        "download": "Download"
      }
    },
    "no_attendees": "This is not attributed to any attendees",
    "listHeader": {
      "title": "Title",
      "status_sign": "Status Signature",
      "status_deposit": "Status Deposit",
      "document_type": "Document type",
      "identity": "Identity",
      "contact_infos": "Address",
      "sign": "Signature",
      "package": "PACK AVANTAGE",
      "regime": "Regime",
      "deposit": "Submission",
      "actions": "Actions",
      "created_by": "Created by"
    },
    "regional_health_agency": "Agence régionale de santé",
    "other_category": {
      "MILITARY_SERVICE": "Military Service",
      "MONACO_MEDICAL_COUNCIL": "Monaco Medical Council",
      "MONACO_PHARMACY_COUNCIL": "Monaco Pharmacy Council"
    },
    "no_reference": "No reference",
    "modal": {
      "title": "A deposit already exist",
      "body": "Are you sure to be willing to submit this deposit again ?"
    },
    "badge": {
      "declaration_sent": "Declaration sent",
      "authorization_sent": "Awaiting notification of a complete deposit",
      "failed": "Bot failed",
      "pending": "Pending",
      "not_sent": "Not sent",
      "convention_authorized": "Convention authorized",
      "convention_refused": "Convention refused",
      "submission_incomplete": "Submission incomplete",
      "validation_pending": "Validation pending",
      "waiting_for_notification": "Waiting for notification of a complete deposit",
      "submission_sent": "Submission sent",
      "canceled": "Canceled"
    },
    "input": {
      "export_as_csv": "Generate doctors list",
      "download": "Download"
    }
  },
  "deposit": {
    "slideover": {
      "title": "Edit a reference",
      "edit": "Edit",
      "cancel": "Cancel",
      "submited_at": "Submited at : {date}",
      "input": {
        "reference": {
          "label": "Reference",
          "placeholder": "Please provide the submission's reference"
        },
        "url": {
          "label": "URL",
          "placeholder": "Please provide the submission's URL"
        },
        "comment": {
          "label": "Comments",
          "placeholder": "Comments"
        },
        "file_type": {
          "label": "File type",
          "placeholder": "Please provide the file type"
        },
        "incomplete_submission_date": "Incomplete Submission Notification Date",
        "authorization_refusal_date": "Authorization Refusal Receipt Date",
        "recommendation_date": "Recommendation Receipt Date",
        "status": "Submission's status",
        "attachments": "Please upload at least one submission file",
        "acceptation_date": "Acceptation Receipt Date",
        "complete_submission_date": "Complete Submission Receipt Date",
        "additional_information": {
          "label": "Additional information",
          "placeholder": "Additional information"
        },
        "submission_date": "Submission date"
      }
    },
    "DECLARATION": "Declaration",
    "AUTHORIZATION": "Authorization",
    "submission_list": "BOT's Submission list",
    "status": {
      "DONE": "Success",
      "FAILED": "Failed",
      "PENDING": "Pending",
      "CONVENTION_AUTHORIZED": "Convention authorized",
      "CONVENTION_REFUSED": "Convention refused",
      "SUBMISSION_INCOMPLETE": "Submission incomplete",
      "VALIDATION_PENDING": "Validation pending",
      "CANCELED": "Canceled",
      "RECOMMENDATION_PENDING": "Recommendation pending",
      "SUBMISSION_SENT": "Submission sent",
      "WAITING_FOR_NOTIFICATION": "Waiting for notification of a complete deposit"
    },
    "submission": {
      "status": {
        "DONE": "Success",
        "FAILED": "Failed",
        "PENDING": "Pending",
        "CONVENTION_AUTHORIZED": "Convention authorized",
        "CONVENTION_REFUSED": "Convention refused",
        "SUBMISSION_INCOMPLETE": "Submission incomplete",
        "VALIDATION_PENDING": "Validation pending",
        "CANCELED": "Canceled",
        "RECOMMENDATION_PENDING": "Recommendation pending",
        "SUBMISSION_SENT": "Submission sent",
        "WAITING_FOR_NOTIFICATION": "Waiting for notification of a complete deposit"
      },
      "document_type": {
        "SUBMISSION_LETTER": "Submission Letter",
        "SUBMISSION_LETTER_COMPLEMENT": "Submission Letter - Additional Information",
        "SUBMISSION_LETTER_MODIFICATION": "Submission Letter - Modification",
        "PS_LETTER_CANCEL": "PS Cancellation Letter",
        "PS_LETTER_MAINTAIN": "PS Maintenance Letter",
        "SUPPLEMENT_INFO_REQUEST": "Request for Additional Information Received",
        "NOTICE_FROM_ORDER": "Notice from the Order",
        "SIGNED_CONVENTION": "Signed Conventions",
        "UNSIGNED_CONVENTION": "Unsigned Conventions",
        "ATTENDEE_LIST": "Attendee List - CSV",
        "CONTRACTS": "Contracts",
        "OTHER": "Other",
        "ZIP": "ZIP for manual deposit"
      }
    },
    "titles": {
      "other_documents": "General joined files",
      "uploaded_documents": "Uploaded joined files"
    },
    "recipient": {
      "MILITARY": "Service de Santé des Armées",
      "NURSE": "Conseil National de l'Ordre des infimiers",
      "DOCTOR": "Conseil National de l'Ordres des Médecins",
      "MASSAGE_THERAPIST": "Conseil National de l'ordre des Masseurs Kinésithérapeutes",
      "MIDWIFE": "Conseil National de l'Ordre des Sages-femmes",
      "DENTIST": "Conseil National de l'Ordre des Chirurgiens-Dentistes",
      "PODIATRIST": "Conseil National de l'Ordre des Pédicures-Podologues",
      "PHARMACISTS_COMMUNITY": "Conseil National de l'Ordre des Pharmaciens Section Officine",
      "PHARMACISTS_INDUSTRY": "Conseil National de l'Ordre des Pharmaciens Section Mines",
      "PHARMACISTS_WHOLESALER": "Conseil National de l'Ordre des Pharmaciens Section Grossistes",
      "PHARMACISTS_ASSISTANT_AND_OTHERS": "Conseil National de l'Ordre des Pharmaciens Section Adjoint",
      "PHARMACISTS_OVERSEAS_DEPARTMENTS_AND_TERRITORIES": "Conseil National de l'Ordre des Pharmaciens Section Outre-Mer",
      "PHARMACISTS_LIBERAL_AND_HOSPITAL_BIOLOGIST": "Conseil National de l'Ordre des Pharmaciens Section Biologie",
      "PHARMACISTS_HEALTHCARE_INSTITUTIONS": "Conseil National de l'Ordre des Pharmaciens Section Hôpital",
      "REGIONAL_HEALTH_AGENCY": "Agence régionale de santé",
      "NONE": "None",
      "MILITARY_SERVICE": "Military Service",
      "MONACO_MEDICAL_COUNCIL": "Monaco Medical Council",
      "MONACO_PHARMACY_COUNCIL": "Monaco Pharmacy Council"
    }
  },
  "transparency": {
    "view": "Consult the event"
  },
  "submission_regime": {
    "NONE": "None",
    "DECLARATION": "Declaration",
    "AUTHORIZATION": "Authorization",
    "MIXED": "Mixed"
  },
  "remaining_submission": {
    "day": "{nb} remaining day",
    "days": "{nb} remaining days",
    "over_one_year": "+365 remaining days"
  },
  "overdue_submission": {
    "day": "Overdue by 1 day",
    "days": "Overdue by {nb} days",
    "over_one_year": "Overdue by +365 days"
  },
  "filter": {
    "status": {
      "label": "Status",
      "values": {
        "archived": "Archived",
        "canceled": "Canceled",
        "published": "Published"
      }
    }
  },
  "attendees_import": {
    "breadcrumb": {
      "attendee_by_import_list": "Importation of attendees",
      "edit": "Edition"
    },
    "title": "List of attendees imports",
    "header": {
      "status": "Status",
      "created_at": "Created at",
      "action": "Actions"
    },
    "status": {
      "SUCCESS": "Success",
      "FAILED": "Failed"
    }
  },
  "actual_details_list": {
    "title": "Benefits details",
    "view_detail": "View detail",
    "reduce_detail": "Reduce details",
    "attribution_of_benefits": "Attribution of benefits",
    "detailed_distribution": "Detailed distribution",
    "header": {
      "advantage_type": "Benefits",
      "total_planned_advantages": "Total planned",
      "total_actual_advantages": "Total actual",
      "total_gap": "Gap"
    },
    "attendee_header": {
      "identity": "Identity",
      "status": "Status",
      "total_advantages": "Total benefits",
      "participation": "Participation",
      "is_billed": "Billing"
    }
  },
  "watchdogs": {
    "disclosures": {
      "only_first_15_occurrences": "Only the first 15 items will be displayed"
    }
  }
}
